var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstAidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.1143 18.3389C24.0834 18.3391 22.4395 19.9827 22.4395 22.0137V25.417H19.0361C17.0049 25.4172 15.3613 27.0613 15.3613 29.0938V30.3203C15.3615 32.3523 17.0065 33.9978 19.0361 33.998H22.4395V37.4902C22.4395 39.5223 24.0846 41.1687 26.1143 41.1689H27.4365C29.4659 41.1689 31.1132 39.523 31.1133 37.4902V33.998H34.5166C36.5444 33.998 38.1912 32.3527 38.1914 30.3203V29.0938C38.1914 27.0606 36.5439 25.417 34.5166 25.417H31.1133V22.0137C31.1133 19.9817 29.465 18.3389 27.4365 18.3389H26.1143ZM20.6572 4C19.0183 4 17.6897 5.32795 17.6895 6.9668L17.6885 9.12598L17.6875 9.87695H35.8564V6.9668C35.8562 5.32844 34.5305 4.00018 32.8896 4H20.6572ZM4.28906 51.0264H3.53906C1.99835 51.0263 0.75 49.7768 0.75 48.2373V13.8975C0.750235 11.6767 2.54978 9.87713 4.77051 9.87695H14.5371V4.49512C14.5371 2.42638 16.2123 0.75 18.2803 0.75H34.9971C37.2195 0.75 39.0174 2.54946 39.0176 4.77051V9.87695H49.709C51.9313 9.8771 53.7293 11.6766 53.7295 13.8975V49.1689C53.7295 50.1952 52.899 51.0262 51.874 51.0264H51.124V52.877C51.1238 53.6349 50.5075 54.2518 49.7471 54.252H42.1689C41.41 54.2519 40.7961 53.6365 40.7959 52.877V51.0264H14.6172V52.877C14.617 53.636 14.0016 54.2518 13.2441 54.252H5.66113C4.90432 54.252 4.28928 53.6369 4.28906 52.877V51.0264Z",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidIcon);
export default __webpack_public_path__ + "static/media/first-aid-icon.934c588292cf3b8e91ef87af4fb19216.svg";
export { ForwardRef as ReactComponent };